export default __webpack_public_path__ + "static/media/singam.aa480864.png";